import { create } from "zustand";
import { IUserVideo } from "@/types/user.types";
import selectColor from "@/components/common/selectColorTypeVideo";
import { SITE_DOMAIN } from "@/constant";

export const useUserVideo = create<IUserVideo>((set) => ({
  data: {
    dynamic: "1",
    name: "",
    sharing: "1",
    showButton: false,
    design_colors_primary: selectColor[0].color,
    design_colors_button: selectColor[0].buttonColor,
    headline: "",
    company: "",
    description: "",
    welcome_screen: "",
    welcome_path: "",
    videos: [
      {
        image: "https://i.ytimg.com/vi/pmTo3fHK9uE/sddefault.jpg",
        name: "Your video headline",
        url: "https://www.youtube.com/watch?v=pmTo3fHK9uE&t=213s&ab_channel=BakeWithAngus",
      },
    ],
    button: "Buy now",
    button_url: "",
    highlight_the_first_video: "0",
    socialItems: [
      {
        id: 0,
        icon: `/social-items/website.svg`,
        url: "",
        type: "website",
      },
      {
        id: 1,
        icon: `/social-items/youtube.svg`,
        url: "",
        type: "youtube",
      },
      {
        id: 2,
        icon: `/social-items/instagram.svg`,
        url: "",
        type: "instagram",
      },
    ],
  },
  config: {},
  addButton: [
    {
      value: "Shop online",
      icon: "",
    },
    {
      value: "Learn more",
      icon: "",
    },
    {
      value: "Apply now",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],

  socialTypes: [
    {
      icon: `/social-items/website.svg`,
      text: "Website",
      active: true,
      type: "website",
    },
    {
      icon: `/social-items/facebook.svg`,
      text: "Facebook",
      active: false,
      type: "facebook",
    },
    {
      icon: `/social-items/twitter.svg`,
      text: "Twitter",
      active: false,
      type: "twitter",
    },
    {
      icon: `/social-items/instagram.svg`,
      text: "Instagram",
      active: true,
      type: "instagram",
    },
    {
      icon: `/social-items/linkedin.svg`,
      text: "Linkedin",
      active: false,
      type: "linkedin",
    },
    {
      icon: `/social-items/youtube.svg`,
      text: "Youtube",
      active: true,
      type: "youtube",
    },
    {
      icon: `/social-items/wp.svg`,
      text: "Whatsapp",
      active: false,
      type: "whatsapp",
    },
    {
      icon: `/social-items/tg.svg`,
      text: "Telegram",
      active: false,
      type: "telegram",
    },
    {
      icon: `/social-items/snap.svg`,
      text: "Snapchat",
      active: false,
      type: "snapchat",
    },
    {
      icon: `/social-items/tiktok.svg`,
      text: "Tiktok",
      active: false,
      type: "tiktok",
    },
  ],
  setReorderVideos: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          videos: [...val],
        },
      };
    });
  },
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setUserVideo: (val) => {
    set((state) => {
      return {
        ...state,
        data: { ...state.data, videos: [...state.data.videos, val] },
      };
    });
  },
  setReorderSocial: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: val,
        },
      };
    });
  },
  setDeleteSocialItem: (index, qrShowId) => {
    set((state) => {
      const afterDeleted = state.data.socialItems.filter((e, i) => {
        if (qrShowId) {
          e.id = e.id > 0 ? e.id - 1 : e.id;
        }

        return i !== index;
      });

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: afterDeleted,
        },
      };
    });
  },
  setSocialItems: (val, type, index, action) => {
    set((state) => {
      if (type === "add") {
        return {
          ...state,
          data: {
            ...state.data,
            socialItems: [...state.data.socialItems, val],
          },
        };
      }
      if (type === "update_value" && action) {
        (state.data.socialItems as any)[index][action] = val;
        return { ...state };
      } else {
        return { ...state, socialItems: val };
      }
    });
  },
  setUserUpdateVideo: (val) => {
    set((state) => {
      const { index, value } = val;
      // change videoes name based on index

      const videos = state.data.videos.map((obj, _index) => {
        if (_index === index) {
          obj.name = value;
        }
        return obj;
      });

      return {
        ...state,
        data: {
          ...state.data,
          videos,
        },
      };
    });
  },
  setUserDeleteVideo: (val) => {
    set((state) => {
      // delete videoes due to index
      state.data.videos.splice(val, 1);
      return {
        ...state,
      };
    });
  },
  setUserParams: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setShowButton: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          showButton: val,
        },
      };
    });
  },

  setSocialTypes: (val) => {
    set((state) => {
      const newSocialTypesState = state.socialTypes.map((obj) => {
        if (
          obj.type.toUpperCase().replace(/\s+/g, "") === val.type.toUpperCase().replace(/\s+/g, "")
        ) {
          return { ...obj, active: val.active };
        }

        return obj;
      });

      return { ...state, socialTypes: newSocialTypesState };
    });
  },
  setDeleteSocialTypes: (val) => {
    set((state) => {
      const deleted = state.data.socialItems.filter(
        (e) =>
          e.type.toUpperCase().replace(/\s+/g, "") !== val.type.toUpperCase().replace(/\s+/g, ""),
      );

      return { ...state, socialItems: deleted };
    });
  },
  destroyUserVideo: () => {
    set(() => {
      return {
        data: {
          dynamic: "1",
          name: "",
          showButton: false,
          sharing: "0",
          design_colors_primary: selectColor[0].color,
          design_colors_button: selectColor[0].buttonColor,
          headline: "",
          company: "",
          description: "",
          welcome_screen: "",
          welcome_path: "",
          videos: [
            {
              image: "https://i.ytimg.com/vi/pmTo3fHK9uE/sddefault.jpg",
              name: "Your video headline",
              url: "https://www.youtube.com/watch?v=pmTo3fHK9uE&t=213s&ab_channel=BakeWithAngus",
            },
          ],
          button: "",
          button_url: "",
          highlight_the_first_video: "0",
          socialItems: [
            {
              id: 0,
              icon: `${SITE_DOMAIN}frontend/icons/website.svg`,
              url: "",
              type: "website",
            },
            {
              id: 1,
              icon: `/social-items/youtube.svg`,
              url: "",
              type: "youtube",
            },
            {
              id: 2,
              icon: `/social-items/instagram.svg`,
              url: "",
              type: "instagram",
            },
          ],
        },
        addButton: [
          {
            value: "Shop online",
            icon: "",
          },
          {
            value: "Learn more",
            icon: "",
          },
          {
            value: "Apply now",
            icon: "",
          },
          {
            value: "Custom",
            icon: "/common/edit-icon.svg",
          },
        ],
        socialItems: [
          {
            icon: `/social-items/website.svg`,
            text: "Check our website",
            type: "website",
          },
          {
            icon: `/social-items/youtube.svg`,
            text: "Youtube",
            type: "youtube",
          },
          {
            icon: `/social-items/instagram.svg`,
            text: "Instagram",
            type: "instagram",
          },
        ],
        socialTypes: [
          {
            icon: `/social-items/website.svg`,
            text: "Website",
            active: true,
            type: "website",
          },
          {
            icon: `/social-items/facebook.svg`,
            text: "Facebook",
            active: false,
            type: "facebook",
          },
          {
            icon: `/social-items/twitter.svg`,
            text: "Twitter",
            active: false,
            type: "twitter",
          },
          {
            icon: `/social-items/instagram.svg`,
            text: "Instagram",
            active: true,
            type: "instagram",
          },
          {
            icon: `/social-items/linkedin.svg`,
            text: "Linkedin",
            active: false,
            type: "linkedin",
          },
          {
            icon: `/social-items/youtube.svg`,
            text: "Youtube",
            active: true,
            type: "youtube",
          },
          {
            icon: `/social-items/wp.svg`,
            text: "Whatsapp",
            active: false,
            type: "whatsapp",
          },
          {
            icon: `/social-items/tg.svg`,
            text: "Telegram",
            active: false,
            type: "telegram",
          },
          {
            icon: `/social-items/snap.svg`,
            text: "Snapchat",
            active: false,
            type: "snapchat",
          },
          {
            icon: `/social-items/tiktok.svg`,
            text: "Tiktok",
            active: false,
            type: "tiktok",
          },
        ],
      };
    });
  },
  deleteItem: (val) => {
    set((state) => {
      delete (state.data as any)[val];

      return { ...state };
    });
  },
  editSocialItems: (val) => {
    set((state) => {
      return { ...state, socialItems: val };
    });
  },
}));
